const AlertIcon = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="icon-alert"
  >
    <g id="Group19">
      <path
        id="Vector"
        d="M7.91926 2.20313L1.51706 13.4068C1.30827 13.7717 1.19888 14.1849 1.19996 14.6053C1.20104 15.0256 1.31255 15.4385 1.52321 15.8023C1.73388 16.1661 2.0363 16.4682 2.40037 16.6784C2.76444 16.8886 3.17736 16.9995 3.59775 17H16.4021C16.8225 16.9995 17.2355 16.8886 17.5995 16.6784C17.9636 16.4682 18.266 16.1661 18.4767 15.8023C18.6874 15.4385 18.7989 15.0256 18.7999 14.6053C18.801 14.1849 18.6916 13.7717 18.4828 13.4068L12.0806 2.20313C11.8701 1.83744 11.567 1.53358 11.2017 1.32237C10.8364 1.11116 10.4219 1 9.99995 1C9.578 1 9.16346 1.11116 8.79817 1.32237C8.43288 1.53358 8.12977 1.83744 7.91926 2.20313Z"
        fill="#CA0D0D"
        stroke="#CA0D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        id="Vector_2"
        d="M9.99683 3.28271V10.6347"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        id="Vector_3"
        d="M9.99688 15.5306C10.6596 15.5306 11.1969 14.9826 11.1969 14.3066C11.1969 13.6306 10.6596 13.0828 9.99688 13.0828C9.33413 13.0828 8.79688 13.6306 8.79688 14.3066C8.79688 14.9826 9.33413 15.5306 9.99688 15.5306Z"
        fill="white"
      />
    </g>
  </svg>
);

export default AlertIcon;
